import i18n from 'i18next';

const supportSite =
	'https://developer.mercedes-benz.com/contact/vehicle_images/technical_inquiry';

const supportLink = (lang) =>
	lang === 'de'
		? `Wenn das Problem weiterhin besteht, wenden Sie sich bitte an den Support unter ${supportSite}.`
		: `If the problem persists, please contact support at ${supportSite}.`;

const messagesDe = {
	400: 'Die Anfrage ist ungültig. Bitte prüfen.',
	404: 'Das Fahrzeug wurde nicht gefunden oder die FIN ist ungültig. Bitte prüfen.',
	401: 'Ihr API Key ist ungültig. Bitte prüfen.',
	403: 'Ihr API Key ist ungültig. Bitte prüfen.',
};

const messagesEn = {
	400: 'Your request is invalid. Please check.',
	404: 'Your VIN key is invalid. Please check.',
	401: 'Your API key is invalid. Please check.',
	403: 'Your API key is invalid. Please check.',
};

const networkMessageDe = 'Keine Verbindung zum Server möglich. Bitte prüfen Sie Ihre Internetverbindung.';
const networkMessageEn = 'Could not reach the server. Please check your internet connection.';

function _handleErrors(err, theObject) {
	const isGerman = (i18n.language || '').startsWith('de');

	if (!err.response) {
		const detail = isGerman ? `${networkMessageDe} ${supportLink('de')}` : `${networkMessageEn} ${supportLink('en')}`;
		return isGerman
			? `Ein Fehler ist aufgetreten für [${theObject}]. ${detail}`
			: `An error occurred for [${theObject}]. ${detail}`;
	}

	const statusCode = err.response.status;

	if (isGerman) {
		const detail = messagesDe[statusCode] || `Bitte prüfen. ${supportLink('de')}`;
		return `Ein Fehler ist aufgetreten [${statusCode}] für [${theObject}]. ${detail}`;
	}

	const detail = messagesEn[statusCode] || `Please check. ${supportLink('en')}`;
	return `An error occurred [${statusCode}] for [${theObject}]. ${detail}`;
}

export default _handleErrors;
